import EstimatedTextInCart from '@/components/EstimatedTextInCart';
import ShowMethodForSoldOut from '@/components/ShowMethodForSoldout';
import { defaultEstimatedText } from '@/constants/string';
import { clickedDiscardSelector } from '@/redux/slice/appbar.slice';
import ruleSlice, { IRuleErrorField, ruleErrorsSelector, ruleSettingsSelector } from '@/redux/slice/rule.slice';
import { IRule } from '@/types/newSetup.type';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const AdvancedSetup = () => {
  const dispatch = useDispatch();
  const ruleSettings = useSelector(ruleSettingsSelector);
  const ruleErrors = useSelector(ruleErrorsSelector);
  const isClickedDiscard = useSelector(clickedDiscardSelector);
  const handleUpdateValue = (key: keyof IRule, value: IRule[keyof IRule]) => {
    dispatch(ruleSlice.actions.handleChange({ key, value }));
  };

  const handleErrors = useCallback(
    (field: IRuleErrorField, msg: string) => {
      dispatch(ruleSlice.actions.handleSetError({ value: { field, msg } }));
    },
    [dispatch],
  );

  const handleSoldOutError = (isEnabledSoldOut: boolean, isEnabledCustomText: boolean) => {
    if (isEnabledSoldOut && isEnabledCustomText && !ruleSettings.soldOutCustomText) {
      handleErrors('customMessageSoldOut', 'This field is required');
    } else {
      handleErrors('customMessageSoldOut', '');
    }
  };

  useEffect(() => {
    if (ruleSettings.soldOutCustomText) {
      handleErrors('customMessageSoldOut', '');
    }
  }, [handleErrors, ruleSettings.soldOutCustomText, isClickedDiscard]);

  return (
    <div>
      <EstimatedTextInCart
        showTextInCart={ruleSettings.showTextInCart}
        onChangeShowTextInCart={(value) => handleUpdateValue('showTextInCart', value)}
        labelText={ruleSettings.cartPageLabelText}
        onChangeLabelText={(value) => handleUpdateValue('cartPageLabelText', value)}
        dateDisplay={ruleSettings.cartPageDateDisplay}
        onChangeDateDisplay={(value) => handleUpdateValue('cartPageDateDisplay', value)}
        orderToShipDays={+ruleSettings.maxPrepDays}
        preDays={+ruleSettings.minPrepDays}
        shipToReceiveDays={+ruleSettings.minPrepDays}
        estDays={+ruleSettings.maxDeliveryDays}
        estText={defaultEstimatedText.method}
        estimatedDateDisplayType={ruleSettings.cartPageDateDisplayType}
        setEstimatedDateDisplayType={(value) => handleUpdateValue('cartPageDateDisplayType', value)}
        customHandleError={handleErrors}
        customError={ruleErrors}
        preOrderDate={ruleSettings.preOrderDate || ''}
        isUsePreOrderDate={ruleSettings.isUsePreOrderDate}
      />

      <div className="mt-12">
        <ShowMethodForSoldOut
          showMethod={ruleSettings.soldOutEnabled ?? false}
          handleChangeStatus={(value) => {
            handleUpdateValue('soldOutEnabled', value);
            handleSoldOutError(value, ruleSettings.soldOutCustomTextEnabled ?? false);
          }}
          handleChangeDisplayType={(value) => {
            handleUpdateValue('soldOutCustomTextEnabled', value);
            handleSoldOutError(ruleSettings.soldOutEnabled ?? false, value);
          }}
          handleChangeText={(value) => {
            handleUpdateValue('soldOutCustomText', value);
            if (!value) {
              handleErrors('customMessageSoldOut', 'This field is required');
            } else {
              handleErrors('customMessageSoldOut', '');
            }
          }}
          soldOutCustomTextEnabled={ruleSettings.soldOutCustomTextEnabled ?? false}
          soldOutText={ruleSettings.soldOutCustomText || ''}
          customShowError={!!ruleErrors.find((error) => error.field === 'customMessageSoldOut')}
        />
      </div>
    </div>
  );
};

export default AdvancedSetup;
